import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { HOST } from 'Constant/Constant';

export const loginApi = createApi({
  reducerPath: 'loginApi',

  baseQuery: fetchBaseQuery({
    baseUrl: `${HOST}`,
  }),

  endpoints: (builder) => ({
    login: builder.mutation({
      query: (loginInfo) => ({
        url: '/admin/login',
        method: 'POST',
        body: loginInfo,
      }),
    }),
    getAdminUserByToken: builder.mutation({
      query: () => ({
        url: '/get-admin-user-by-token',
        method: 'GET',
        cache: "no-store",
        headers: {
          authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }),
    }),
    forgotPassword: builder.mutation({
      query: (data) => ({
        url: '/admin/forgot-password',
        method: 'POST',
        body: data,
      }),
    }),
    verifyUser: builder.mutation({
      query: (data) => ({
        url: '/admin/verify-user',
        method: 'POST',
        body: data,
      }),
    }),
  }),
});

export const {
  useLoginMutation,
  useGetAdminUserByTokenMutation,
  useForgotPasswordMutation,
  useVerifyUserMutation,
} = loginApi;
